import { requestData } from "config/services/datasets";
import { addLoadingFlag, changeMessageLoading, subLoadingFlag } from "./loading";
import { SERVER } from "config/server.config";
import { MESSAGES, SCOPE } from "config/constants";
import { Dispatch } from 'redux';
import { PlayerParticipationState, PlayerParticipationAction } from '../types';


export const updatePlayerParticipationData = (playerParticipationData: PlayerParticipationState, gameId:string ) => {
    return {
      type: PlayerParticipationAction.SET_PLAYER_PARTICIPATION,
      playerParticipationData,
      gameId
    };
  };


export const loadPlayerParticipation = (practiceId:string, withLoader: boolean) => {
    return async (dispatch: Dispatch) => {
      if(withLoader){
        dispatch(addLoadingFlag(SCOPE.VIEW.PRACTICE.TRACKING.PAGE+':'+practiceId));
      }
      const results = await requestData(SERVER.PLAYER_PARTICIPATION(practiceId));
      if (results && results.length && results[0] && results[0].participation && results[0].participation.length) {
        dispatch(updatePlayerParticipationData(results[0].participation, practiceId));
      } else {
        dispatch(changeMessageLoading(SCOPE.VIEW.PRACTICE.TRACKING.PAGE+':'+practiceId, MESSAGES.EMPTY));
      }
      dispatch(subLoadingFlag(SCOPE.VIEW.PRACTICE.TRACKING.PAGE+':'+practiceId));
    };
  };